import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {DocScanWebComponentResult} from "../models/document-scanning.models";
import {SharedConfigService} from "./shared-config.service";


@Injectable({
  providedIn: 'root'
})
export class DocumentScanningService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private configService: SharedConfigService
  ) {
    this.configService.getConfig().then((config) => {
      this.apiUrl = config.apiUrl;
    })
  }

  scanDocument(formTemplateCode: string, docScanWebComponentResult: DocScanWebComponentResult, isBackoffice: boolean) {
    const uid = sessionStorage.getItem('uid');

    return this.httpClient.post(
      `${this.apiUrl}/document/scan/${formTemplateCode}/${uid}?isBackoffice=${isBackoffice}`,
      docScanWebComponentResult
      );
  }
}
